import { useState, useCallback } from 'react';

export default () => {
  const [, setState] = useState(0);

  const handleUpdate = useCallback(() => {
    setState(cnt => cnt + 1);
  }, []);

  return handleUpdate;
};
